import { Checkbox, Input, Modal } from 'antd'
import React, { useState } from 'react'
import { MODAL_BREDD, MODAL_GRIND, MODAL_KNAPP, modalTitel } from '../modalStil'

/**
 * ArendeIdModal – frågar efter ÄrendeID i samband med att besöket sparas.
 *
 * ÄrendeID är det enda administrativa i besöket och sällan något handläggaren har i
 * huvudet hemma hos brukaren. Därför går det att skjuta upp – men bara som ett aktivt
 * val. Ett tyst överhopp skulle göra att luckan aldrig syns; en ikryssad ruta gör att
 * besöket flaggas som ofullständigt och kan kompletteras från översikten.
 *
 * Inget förifylls från tidigare besök: beställningen kan ha ändrats mellan besöken,
 * och ett ärvt nummer skulle dölja just den förändringen.
 */

export interface ArendeIdModalProps {
  open: boolean
  sparar?: boolean
  /** null när handläggaren valt att fylla i senare. */
  onBekrafta: (arendeId: string | null) => void
  onAvbryt: () => void
}

const ArendeIdModal: React.FC<ArendeIdModalProps> = ({ open, sparar, onBekrafta, onAvbryt }) => {
  const [varde, setVarde] = useState('')
  const [senare, setSenare] = useState(false)

  const kanSpara = varde.trim().length > 0 || senare

  return (
    <Modal
      open={open}
      {...MODAL_GRIND}
      title={modalTitel('Fyll i ÄrendeID')}
      okText="Spara besök"
      okButtonProps={{ ...MODAL_KNAPP, disabled: !kanSpara, loading: sparar }}
      onOk={() => onBekrafta(senare ? null : varde.trim())}
      cancelText="Avbryt"
      cancelButtonProps={MODAL_KNAPP}
      onCancel={onAvbryt}
      width={MODAL_BREDD}
    >
      <div className="flex flex-col gap-3">
        <Input
          autoFocus
          value={varde}
          disabled={senare}
          onChange={(e) => setVarde(e.target.value)}
          onPressEnter={() => kanSpara && onBekrafta(senare ? null : varde.trim())}
          placeholder="t.ex. 10101"
          style={{ width: 220, fontSize: 16 }}
        />

        <Checkbox
          checked={senare}
          onChange={(e) => {
            setSenare(e.target.checked)
            if (e.target.checked) setVarde('')
          }}
        >
          Jag fyller i det senare
        </Checkbox>

        <div className="flex flex-col gap-1 text-sm text-gray-500">
          <span>ÄrendeID återfinns i verksamhetssystemet och kopplar Målindex till rätt beställning.</span>
          {senare && <span>Besöket sparas som ofullständigt. Komplettera i översikten när du har ÄrendeID.</span>}
        </div>
      </div>
    </Modal>
  )
}

export default ArendeIdModal
